/** Route table + matcher. Pure so it can be unit-tested without a browser. */

export const ROUTES = [
  { name: "home", pattern: "/" },
  { name: "search", pattern: "/search" },
  { name: "restaurant", pattern: "/r/:slug" },
  { name: "login", pattern: "/login" },
  { name: "register", pattern: "/register" },
  { name: "verify", pattern: "/verify" },
  { name: "forgot", pattern: "/forgot-password" },
  { name: "reset", pattern: "/reset-password" },
  { name: "profile", pattern: "/me" },
  { name: "admin", pattern: "/admin" },
  { name: "adminUsers", pattern: "/admin/users" },
  { name: "adminIngest", pattern: "/admin/ingest" },
  { name: "adminRefresh", pattern: "/admin/refresh" },
  { name: "adminMatches", pattern: "/admin/matches" },
  { name: "adminRestaurantNew", pattern: "/admin/restaurants/new" },
  { name: "adminRestaurantEdit", pattern: "/admin/restaurants/:id" },
];

/** Matches a pathname against ROUTES, returning { name, params } (name "notFound" when nothing fits). */
export function matchRoute(pathname, routes = ROUTES) {
  const path = normalizePath(pathname);
  const segments = path === "/" ? [""] : path.slice(1).split("/");

  for (const route of routes) {
    const routeSegments = route.pattern === "/" ? [""] : route.pattern.slice(1).split("/");
    if (routeSegments.length !== segments.length) continue;
    const params = {};
    let matched = true;
    for (let i = 0; i < routeSegments.length; i += 1) {
      const expected = routeSegments[i];
      const actual = segments[i];
      if (expected.startsWith(":")) {
        if (!actual) { matched = false; break; }
        params[expected.slice(1)] = decodeURIComponent(actual);
      } else if (expected !== actual) {
        matched = false;
        break;
      }
    }
    if (matched) return { name: route.name, params, path };
  }
  return { name: "notFound", params: {}, path };
}

export function normalizePath(pathname) {
  const value = String(pathname ?? "/").split("?")[0].split("#")[0];
  if (!value.startsWith("/")) return `/${value}`;
  if (value.length > 1 && value.endsWith("/")) return value.slice(0, -1);
  return value;
}

export function searchUrl(query, extra = {}) {
  const params = new URLSearchParams();
  if (query) params.set("q", query);
  for (const [key, value] of Object.entries(extra)) {
    // An array is a set of alternatives (a checkbox group), so it becomes repeated parameters.
    if (Array.isArray(value)) {
      for (const item of value) {
        if (item !== undefined && item !== null && item !== "") params.append(key, String(item));
      }
    } else if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  }
  const qs = params.toString();
  return qs ? `/search?${qs}` : "/search";
}

export function restaurantUrl(restaurant) {
  return `/r/${encodeURIComponent(restaurant?.slug ?? restaurant?.id ?? "")}`;
}
